import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useBusinessesUIContext } from "../BusinessesUIContext";

const prepareFilter = (queryParams, values) => {
  const { status, searchText, is_purchased } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by status
  if (status !== "" && status !== "-1" && typeof status !== "undefined") {
    filter.status = +status;
  }
  // Filter by premium
  if (is_purchased !== "" && is_purchased !== "-1" && typeof is_purchased !== "undefined") {
    filter.is_purchased = is_purchased === "true" || is_purchased === true;
  }
  // Filter by all fields
  filter.name = searchText;
  if (searchText) {
    filter.email = searchText;
    filter.id = searchText;
  }
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function BusinessesFilter({ listLoading }) {
  // Businesses UI Context
  const businessesUIContext = useBusinessesUIContext();
  const businessesUIProps = useMemo(() => {
    return {
      setQueryParams: businessesUIContext.setQueryParams,
      queryParams: businessesUIContext.queryParams,
    };
  }, [businessesUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(businessesUIProps.queryParams, values);
    if (!isEqual(newQueryParams, businessesUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      businessesUIProps.setQueryParams(newQueryParams);
    }
  };

  const handleFieldChange = (field, val, currentValues, setFieldValue) => {
    setFieldValue(field, val);
    const updatedValues = { ...currentValues, [field]: val };
    applyFilter(updatedValues);
  };

  const isTabSpecific = ["approved", "rejected", "pending", "draft", "reported"].includes(
    window.location.pathname.split("/")[2]
  );

  return (
    <>
      <Formik
        initialValues={{
          status: isTabSpecific ? "" : "-1",
          is_purchased: "",
          searchText: "",
        }}
        onSubmit={(values) => {
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right mb-4">
            <div className="form-group row align-items-center mb-0">
              {!isTabSpecific && (
                <div className="col-lg-3 col-md-4 mb-3">
                  <select
                    className="form-control"
                    name="status"
                    placeholder="Filter by Status"
                    onChange={(e) => {
                      handleFieldChange("status", e.target.value, values, setFieldValue);
                    }}
                    onBlur={handleBlur}
                    value={values.status}
                  >
                    <option value="-1">All Statuses</option>
                    <option value="0">Approved</option>
                    <option value="1">Pending</option>
                    <option value="2">Rejected</option>
                    <option value="4">More Info</option>
                    <option value="5">Draft</option>
                  </select>
                  <small className="form-text text-muted">
                    <b>Filter</b> by Status
                  </small>
                </div>
              )}

              <div className="col-lg-3 col-md-4 mb-3">
                <select
                  className="form-control"
                  name="is_purchased"
                  placeholder="Filter by Premium"
                  onChange={(e) => {
                    handleFieldChange("is_purchased", e.target.value, values, setFieldValue);
                  }}
                  onBlur={handleBlur}
                  value={values.is_purchased}
                >
                  <option value="">All (Premium & Standard)</option>
                  <option value="true">⭐ Premium Businesses Only</option>
                  <option value="false">Standard / Free Only</option>
                </select>
                <small className="form-text text-muted">
                  <b>Filter</b> by Premium
                </small>
              </div>

              <div className="col-lg-4 col-md-4 mb-3">
                <input
                  type="text"
                  className="form-control"
                  name="searchText"
                  placeholder="Search by business name or email..."
                  onBlur={handleBlur}
                  value={values.searchText}
                  onChange={(e) => {
                    handleFieldChange("searchText", e.target.value, values, setFieldValue);
                  }}
                />
                <small className="form-text text-muted">
                  <b>Search</b> in all fields
                </small>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}
